import * as React from "react";
import { LoadState, SelectFieldSchema, useGetDatasourceOptions } from "@generation/core";
import { notNullOrUndefined } from "@core/utils";
import { Spinner } from "@shared/common";

import { useDataContext, getArrayValueFromObject, getValueFromObject } from "@generation/overview-core";
import { ItemValue } from "../Components/ItemValue";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { useReadContainerPropsContext } from "../Context/Read/ReadContainerPropsContextProvider";

interface IMultiSelectField {
  field: SelectFieldSchema;
  name: string;
}

export const MultiSelectField = withHideOnFieldHoc(
  withRenderFieldHoc((props: IMultiSelectField): JSX.Element => {
    const readContainerProps = useReadContainerPropsContext();
    const dataContext = useDataContext();

    const { options, loadState } = readContainerProps?.fieldDefaults?.select
      ?.usesDatasourcesOrOptionsInOverview
      ? useGetDatasourceOptions({
          field: props.field,
          name: props.name,
          getValue: (key: string) => getValueFromObject(dataContext, key)
        })
      : { options: null, loadState: LoadState.loaded };

    const values = getArrayValueFromObject(dataContext, props.name);

    const [presentationValues, setPresentationValues] = React.useState<string[] | null>(
      readContainerProps?.fieldDefaults?.select?.usesDatasourcesOrOptionsInOverview ? null : values
    );

    React.useEffect(() => {
      if (readContainerProps?.fieldDefaults?.select?.usesDatasourcesOrOptionsInOverview) {
        if (values && options && options.length > 0) {
          setPresentationValues(
            values
              .map((value) => options?.find((item) => item.value === value)?.label ?? undefined)
              .filter(notNullOrUndefined)
              .map((value) =>
                props.field?.formatSelectedLabelValue ? props.field?.formatSelectedLabelValue(value) : value
              )
              .filter(notNullOrUndefined)
          );
        }
      }
    }, [values, options]);

    if (loadState === LoadState.loading) {
      return <Spinner loading={true} />;
    }

    if (presentationValues && presentationValues.length) {
      if (props.field.showMultiSelectValueCommaSeparated === true) {
        return <ItemValue value={presentationValues.join(", ")} />;
      }

      return (
        <ol className="read-list" id={props.name}>
          {presentationValues.map((item) => (
            <li className="read-list__item" key={item}>
              <ItemValue value={item} />
            </li>
          ))}
        </ol>
      );
    }

    return <></>;
  })
);
